import { t } from "i18next";
import { Athlete, AthleteMeasurement } from "../../interfaces/athlete";
import moment from 'moment';
import ReactECharts from 'echarts-for-react';
import chartsIcon from "../../assets/images/charts.svg";

interface AthleteFMChartProps {
    athlete: Athlete;
}

export function AthleteFMChart(props: AthleteFMChartProps) {
    const options = {
        xAxis: {
            type: 'category',
            data: props.athlete.measurement.map((m: AthleteMeasurement) => {
                return moment(m.measurement_date).format('DD/MM');
            })
        },
        yAxis: {
            type: 'value',
            axisLabel: {
                formatter: '{value} %'
            }
        },
        series: [
            {
                data: props.athlete.measurement.map((m: AthleteMeasurement) => {
                    return m.fm;
                }),
                type: 'line',
                smooth: true,
                color: 'green',
                label: {
                    show: true,
                    position: 'top',
                    formatter: '{c} %'
                }
            }
        ]
    }

    return (
        <div className="athlete-weight-chart-container chart-box">
            <h3 className="chart-title">
                <img src={ chartsIcon } alt={ t("Fat mass")} />
                { t("Fat mass") }
            </h3>
            <div className="chart-content">
                <ReactECharts option={ options } />
            </div>
        </div>
    );
}